/**
 * TOSS Web Application — как называются две двери
 *
 * Отдельным файлом от `BrandWordmark`, потому что правило `react-refresh/only-export-components`
 * запрещает делить модуль между компонентом и константами: страница с обоими перестаёт
 * обновляться на лету.
 */

/** Какая из двух дверей: внутренняя система или кабинет заказчика. */
export type BrandSurface = 'internal' | 'client';

/**
 * Доступное имя ссылки и заголовок вкладки. Держать рядом с разметкой: `aria-label` из двух
 * слов и надпись из двух слов должны совпадать, иначе скринридер называет одно, а глаз читает
 * другое.
 */
export const BRAND_LABELS: Record<BrandSurface, string> = {
  internal: 'ТОСС АТМОСФЕРА',
  client: 'ТОСС — личный кабинет',
};

/** Вторая строка под именем. У кабинета она есть, у внутренней системы имя самодостаточно. */
export const BRAND_SUBTITLES: Partial<Record<BrandSurface, string>> = {
  client: 'Личный кабинет',
};

